import {Injectable, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Injectable(
  {providedIn: 'root'}
)
export class RouteAuthService {
  routerSubscription: Subscription;
  main_menu;
  public restricted_buttons: {
    export: boolean
  };

  constructor(public router: Router) {
    this.resetRestrictedButtons();
  }

  searchPath(_menu: Array<any>, path: string) {
    const menu = [..._menu];
    let has_path = false;
    if (path === '/login' || path === '/new-password' || path === '/forgot-password' || path === '/register' || path === '/paymentProcessTerms' || path === '/contractTerms' || path === '/agreementForm' || path === '/trainingExport' || path === '/consentForm' || path === '/reports' || path === '/verification' ||  path === '/scan-upload' || path === '/customer-landing' || path === '/calculator') {
      return true;
    }
    menu && menu.forEach(item => {
      /*only check path upto 2 levels. eg /app/doctors*/
      let path_limit_arr = path.split('/').filter(d => d && d !== '');
      let path_limit = path_limit_arr.length;
      if (Number(path_limit_arr[path_limit_arr.length - 1])) {
        path_limit -= path_limit;
        path_limit_arr = path_limit_arr.slice(0, path_limit);
        path_limit_arr.push('*');
      }
      const loop_path = item.path.split('/');
      const find_path = path.split('/');
      const intersection_of_paths = [...loop_path.filter(d => !find_path.includes(d)), ...find_path.filter(d => !loop_path.includes(d))];
      if ((intersection_of_paths.length === 0)
        || (intersection_of_paths.length === 2 && intersection_of_paths[0] === '*')
        || (intersection_of_paths.length === 1 && Number(intersection_of_paths[0]))) {
        has_path = true;
      } else {
        if (item.path === '/' + path_limit_arr.join('/')) {
          has_path = true;
        } else if (item.submenu) {
          if (this.searchPath(item.submenu, path)) {
            has_path = true;
          }
        }
      }
    });
    return has_path;
  }

  searchRestricted(menu: Array<any>, path: string, button: string) {
    let restricted = false;
    if (menu) {
      for (const item of menu) {
        let path_limit_arr = path.split('/').filter(d => d && d !== '');
        let path_limit = path_limit_arr.length;
        if (Number(path_limit_arr[path_limit_arr.length - 1])) {
          path_limit -= 1;
          path_limit_arr = path_limit_arr.slice(0, path_limit);
          path_limit_arr.push('*');
        }
        /*only check path upto 2 levels. eg /app/doctors*/
        if (item.path === '/' + path_limit_arr.join('/') && item.restricted_items) {
          restricted = item.restricted_items.split(',').includes(button);
        } else if (item.submenu) {
          restricted = this.searchRestricted(item.submenu, path, button);
        }

        if (restricted) {
          break;
        }
      }
    }
    return restricted;
  }

  routeAuth(main_menu) {
    const _this = this;
    _this.main_menu = main_menu;

    if (_this.routerSubscription) {
      _this.routerSubscription.unsubscribe();
    }

    _this.routerSubscription = _this.router.events
      .subscribe((event: NavigationEnd) => {
          if (event instanceof NavigationEnd) {
        _this.resetRestrictedButtons();
          if (_this.main_menu) {
            for (const key in _this.restricted_buttons) {
              if (_this.restricted_buttons.hasOwnProperty(key)) {
                const result = _this.searchRestricted(_this.main_menu, _this.router.routerState.snapshot.url.split('?')[0], key);
                _this.restricted_buttons[key] = result;
              }
            }
            if (!_this.searchPath(_this.main_menu, event.url.split('?')[0])) {
              this.router.navigate(['/app/finance-customer']);
            }
          }
      }
    });
    if (main_menu) {
      for (const key in _this.restricted_buttons) {
        if (_this.restricted_buttons.hasOwnProperty(key)) {
          _this.restricted_buttons[key] = _this.searchRestricted(main_menu, _this.router.url.split('?')[0], key);
        }
      }
      if (!_this.searchPath(main_menu, _this.router.url.split('?')[0]) && !this.router.url.includes('app/open-api')) {
        if (!this.router.url.includes('/migrate')) {
          _this.router.navigate(['/app/finance-customer']);
        }
      }
    }
  }

  private resetRestrictedButtons() {
    this.restricted_buttons = {
      export: false
    };
  }
}